import React from 'react';

export default function ReadyScreen({ onSubmit, isSubmitting, submitError, submissionState, email, onRetrySubmission }) {
  if (submissionState === 'awaiting_magic_link') {
    return (
      <div className="view on" data-testid="ready-screen">
        <div className="gateway-center" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '24px' }}>&#9993;&#65039;</div>
          <h1 style={{ marginBottom: '16px' }}>One more step</h1>
          <p className="dim" style={{ marginBottom: '8px', lineHeight: '1.6' }}>
            We've sent a sign-in link to <strong style={{ color: 'var(--tx)' }}>{email}</strong>. Click the link in your email, then come back here — your assessment will be submitted automatically.
          </p>
          <p className="hint-text" style={{ marginBottom: '24px' }}>
            Your answers are saved. Nothing will be lost.
          </p>
          <button
            className="btn btn-s"
            onClick={onRetrySubmission}
            data-testid="retry-submission-btn"
            style={{ width: '100%' }}
          >
            Retry Submission
          </button>
        </div>
      </div>
    );
  }

  if (isSubmitting) {
    return (
      <div className="view on" data-testid="ready-screen">
        <div className="gateway-center" style={{ textAlign: 'center' }}>
          <h1>Processing your assessment...</h1>
          <p className="dim">Please wait while we securely submit your responses.</p>
          <div className="tension-track">
            <div className="tension-fill" style={{ width: '100%' }}></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="view on" data-testid="ready-screen">
      <div className="gateway-center" style={{ textAlign: 'center' }}>
        <h1>Navigation complete.</h1>
        <p className="desc">
          You've answered all questions. Submit to generate your personalised AI readiness report.
        </p>
        {submitError && (
          <div style={{
            padding: '16px 20px',
            marginBottom: '16px',
            textAlign: 'left',
            background: 'rgba(239,68,68,0.08)',
            border: '1px solid rgba(239,68,68,0.3)',
            borderRadius: '12px',
          }}>
            <strong style={{ color: 'var(--tx)' }}>Submission failed</strong>
            <br />
            <span className="dim" style={{ fontSize: '0.9rem' }}>{submitError}</span>
          </div>
        )}
        <button
          className="btn btn-p"
          onClick={onSubmit}
          disabled={isSubmitting}
          data-testid="submit-assessment-btn"
          style={{ width: '100%' }}
        >
          {submitError ? 'Retry Submission' : 'Submit Assessment Now'}
        </button>
      </div>
    </div>
  );
}
